<template lang="pug">
    .model-list-gzzoc(ref="list-container")
        logo
        user-nav
        .content
            //- .title(:class="titleClass")
            .title-text 常见致盲、致畸、致死疾病的人工智能筛查诊断系统
            .title-sub-text 研发和临床试验
            .model-area(ref="model-area")
                .eyeball-area(ref="eyeball" v-if="list && list.length")
                    eyeball
                        .iris-c(ref="iris")
                .circle(v-if="list && list.length")
                    // eyeball的动画完成需要1s
                    svg(xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="1000" height="1000"
                        viewBox="0 0 1000 1000"
                        preserveAspectRatio="xMidYMin slice")
                        circle(cx="500" cy="500" r="0" style="stroke: #FFF; fill: none;")
                            animate(id="c1" attributeName="r" from="250" to="350" dur="0.4" begin="1" fill="freeze")
                        circle(cx="500" cy="500" r="0" style="stroke: #FFF; fill: none;")
                            animate(attributeName="r" from="350" to="500" dur="0.6" begin="c1.end" fill="freeze")
                .model-list(v-if="list && list.length")
                    .model-item(v-for="(item, index) in list",
                        :class="{disabled: item.status !== 'enable'}",
                        v-itemmove="{index: index, total: list.length}"
                        ref="item")
                        //- img.item-img(:src="imageList[index]")
                        .item-content
                            .item-title {{item.name}}
                        .item-ops
                            el-button.gzzoc-button-primary-small.predict-button(@click="toModel(item)") {{$t('startPredict')}}
                                //- @mouseenter.native="enterModelItem"
                                //- @mouseleave.native="leaveModelItem") {{$t('startPredict')}}
            //- wave-points.wave-points
</template>

<script>
import Logo from 'components/logo';
import WavePoints from 'components/wave-points';
import ls from '@/utils/local-storage';
import _ from 'lodash';
import UserNav from 'components/user-nav';
import Eyeball from '@/views/model/components/eyeball';

import image1 from 'public/images/gzzoc/myopia_pic.png';
import image2 from 'public/images/gzzoc/congenital_pic.png';
import image3 from 'public/images/gzzoc/ocular_pic.png';
import image4 from 'public/images/gzzoc/senile_pic.png';
import image5 from 'public/images/gzzoc/hepatobiliary_pic.png';

/**
 * 计算方法同 components/gzzoc-model-basic
 */
function getModelAreaSize () {
    let top = 300;
    let clientHeight = window.document.body.clientHeight;
    let height = Math.max(clientHeight - top, 600);
    return {
        width: height * 2,
        height,
        top,
    };
}

/**
 * model-item位置计算与更新
 * 假设modal-area底部的中点A为圆形的中心，model-item的图片的中心B为model-item的位置中心
 * 先计算A、B连线和垂直方向的夹角α
 * modelItem到左边框的距离 = 圆形半径 + sinα * AB长
 * modelItem到有边框的距离 = 圆形半径 - cosaα * AB长
 */
function updateModalItem (el, index, total, update = false) {
    let modelSize = getModelAreaSize();
    let r = modelSize.height;
    let imgWidth = 220;
    let imgHeight = 174;
    // 1 ~ 5 的夹角分别为 -60、-30、0、30、60
    let tIndex = (total - 1) / 2;
    let angle = (index - tIndex) * 2 * 13;
    function setElPosition (radius) {
        let x = r + Math.sin(angle * Math.PI / 180) * radius;
        let y = r - Math.cos(angle * Math.PI / 180) * radius;
        let left = (x - imgWidth / 2) + 'px';
        let top = (y - imgHeight / 2) + 'px';
        el.style.left = left;
        el.style.top = top;
    }
    if (update) {
        // 如果modelItem不是首次渲染，只需要更新modelItem的位置
        el.style.visibility = 'visible';
        setElPosition(r);
    } else {
        // 如果modelItem是首次渲染，则modelItem的初始位置到圆心的中点的距离是2/3个半径，然后在移动到半径处
        el.style.visibility = 'hidden';
        setElPosition(r * 2 / 3);
        let delay = '0s';
        let dur = '0.3s';
        el.style.transition = `left ${dur} linear ${delay}, top ${dur} linear ${delay}`;
        setTimeout(() => {
            el.style.visibility = 'visible';
            setElPosition(r);
        // eyeball 的动画 + circle 的动画完成总共需要2s
        // 间隔 0.3s 执行
        }, 1000 * (2 + 0.3 * index));
    }
}

export default {
    data () {
        return {
            list: [],
            imageList: [
                image1,
                image2,
                image3,
                image4,
                image5
            ],
        };
    },
    directives: {
        itemmove: {
            bind (el) {
                el.style.visibility = 'hidden';
            },
            inserted (el, binding) {
                let {index, total} = binding.value;
                updateModalItem(el, index, total);
            },
            update (el, binding) {
                let {index, total} = binding.value;
                updateModalItem(el, index, total, true);
            }
        }
    },
    components: {
        Logo,
        WavePoints,
        UserNav,
        Eyeball
    },
    mounted () {
        this.resizeThrottle = _.throttle(this.onWindowSizeChange.bind(this), 1000);
        window.addEventListener('resize', this.resizeThrottle);
        this.setModelAreaSize();
        this.getData();
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeThrottle);
        this.resizeThrottle = null;
    },
    methods: {
        getData () {
            this.list = [];
            this.$http.get('mli/predict_model/model_list').then(resp => {
				var obj = _.get(resp, 'body.value.data');
                var data = [], arr = [], acceptance = ['青光眼诊断', '视网膜母细胞瘤病理图像检测系统', '脊柱侧弯诊断', '糖尿病视网膜病变智能分级系统', '中风智能预测系统']
                for(var i in obj) {
                    arr = [...obj[i], ...arr]
                }
                arr.forEach(item => {
                    if(acceptance.includes(item.name)) data.push(item)
                })
                this.list = data
            });
        },
        setModelAreaSize () {
            let size = getModelAreaSize();
            let modelArea = this.$refs['model-area'];
            modelArea.style.top = size.top + 'px';
            modelArea.style.width = size.width + 'px';
            modelArea.style.height = size.height + 'px';
            let clientHeight = window.document.clientHeight;
            let newHeight = Math.max(clientHeight, size.height + 350);
            window.document.clientHeight = newHeight;
        },
        onWindowSizeChange () {
            this.setModelAreaSize();
            this.$forceUpdate();
        },
        enterModelItem (event) {
            let target = event.target.parentNode.parentNode;
            let img = target.getElementsByClassName('item-img')[0];
            img.style.transform = 'scale(1.1, 1.1)';
        },
        leaveModelItem (event) {
            let target = event.target.parentNode.parentNode;
            let img = target.getElementsByClassName('item-img')[0];
            img.style.transform = '';
        },
        toModel (model) {
            if (model.status === 'thirdurl' && model.url) { // 非模型情况跳转
                window.open(model.url)
                return
            }
            if (model.status !== 'enable') {
                return;
            }
            if (model.url) { // 非模型情况跳转
                window.open(model.url)
                return
            }
            this.$router.push({
                name: 'modelDetail',
                params: {
                    id: model.model_id,
                    type: model.model_type
                }
            });
        },
    },
    computed: {
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        }
    }
};
</script>
<style lang="sass" scoped>

    @keyframes eyeball-animate
        0%
            top: 100%
        100%
            top: 33.3%
    @keyframes iris-animate
        0%
            width: 0
            height: 0
        100%
            width: 100%
            height: 100%
    .model-list-gzzoc
        background: url(~public/images/gzzoc/bg.jpg) no-repeat fixed center top / cover
        height: 100%
        min-height: 900px
        overflow-y: hidden
        width: 100%
        min-width: 1150px
        padding-bottom: 100px
        position: relative
    .content
        width: 100%
        height: 100%
        margin: 0 auto
        position: absolute
        top: 0
        left: 0
        z-index: 1
        overflow-y: hidden
        .title
            width: 698px
            height: 157px
            position: absolute
            top: 80px
            left: 50%
            transform: translateX(-50%)
            background: url(~public/images/gzzoc/front-title-cn.svg) no-repeat top left / 100% 100%
            &.en
                background-image: url(~public/images/gzzoc/front-title-en.svg)
        .title-text
            width: 90%
            height: 60px
            text-align: center
            position: absolute
            top: 90px
            left: 50%
            transform: translateX(-50%)
            font-size: 40px
        .title-sub-text
            width: 90%
            height: 60px
            text-align: center
            position: absolute
            top: 156px
            left: 47%
            transform: translateX(-50%)
            font-size: 50px
    .model-area
        // 宽高比恒定为 2 : 1
        width: 1200px
        height: 600px
        position: absolute
        top: 350px
        left: 50%
        transform: translateX(-50%)
    .circle
        width: 100%
        height: 0
        padding-top: 60%
        position: absolute
        top: 0
        left: 0
        svg
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
    .eyeball-area
        width: 66.67%
        height: 0
        padding-top: 66.67%
        position: absolute
        top: 33.3%
        left: 50%
        transform: translateX(-50%)
        animation: eyeball-animate 1s
        .eyeball-wrapper
            width: 100%
            position: absolute
            top: 0
            left: 0
        .iris-c
            width: 0
            height: 0
            position: absolute
            left: 50%
            top: 50%
            transform: translate(-50%, -50%)
            background: url(~public/images/gzzoc/iris.svg) no-repeat left top / 100% 100%
            mix-blend-mode: screen
            animation: iris-animate 0.8s linear 1s forwards
    .model-list
        width: 100%
        height: 0
        padding-top: 50%
        position: absolute
        top: 0
        left: 0
        .model-item
            position: absolute
            width: 220px
            text-align: center
            // transition: left 1s, top 1s
            .item-img
                width: 200px
                height: 174px
                transition: transform 0.5s
            .item-title
                font-family: PingFangSC-Semibold
                font-size: 20px
                color: #333333
                letter-spacing: 0.57px
                text-align: center
                margin-top: 16px
            .predict-button
                font-family: PingFangSC-Semibold
                font-size: 14px
                color: #FFFFFF
                text-align: center
                margin-top: 16px
</style>
